import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '150px',
    borderRadius: '8px',
    border: `0.5rem solid ${theme.palette.common.white}`,
    backgroundColor: theme.palette.offwhite.main,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    padding: 0,
  },
  banner: {
    width: '100%',
    height: '100%',
  },
  image: {
    width: '300px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  textContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  headline: {
    ...theme.typography.h5,
    color: theme.palette.blue.dark,
    lineHeight: '32px',
    marginBottom: theme.spacing(1),
  },
  body: {
    ...theme.typography.body1,
    lineHeight: 'normal',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: theme.spacing(1),
  },
  button: {
    textAlign: 'center',
    height: 'auto',
  },
}))

function CtaBanner(props) {
  const { ctaImage, ...rest } = props
  const classes = useStyles()

  return (
    <Box className={classes.root} {...rest}>
      <Grid container className={classes.banner}>
        <Grid
          item
          xs={3}
          className={classes.image}
          style={{ backgroundImage: `url(${ctaImage})` }}
          title="golfers"
        />
        <Grid item xs={6}>
          <Box className={classes.textContainer}>
            <Typography className={classes.headline}>Discover Golf Events Near You!</Typography>
            <Typography className={classes.body}>Search for fun things to do in your area led by PGA Professionals.</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} className={classes.actions}>
          <ButtonCta
            className={classes.button}
            size="small"
            variant="contained"
            color="primary"
            dataAttrs={{
              'aria-label': 'Find events near you',
              'data-gtm-button-name': 'find-events-cta',
              'data-gtm-cta-position': 'banner',
            }}
            href="/golf-lessons"
          >
            Find Events Near You
          </ButtonCta>
        </Grid>
      </Grid>
    </Box>
  )
}

CtaBanner.propTypes = {
  ctaImage: PropTypes.string,
}

export default CtaBanner
